<template>
    <div class="card-body"><slot /></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({ name: 'CCardBody' });
</script>
